/**
 * The org switcher's top entry for anyone with managed clients. A restricted
 * member (acctMemberClientScope allow-list on their reseller membership) sees
 * an ASSIGNED slice of the book, so calling it "all clients" would be a lie
 * the rest of the UI then has to live down. Pure so the label rule is
 * vitest-testable without booting main.js.
 */
export function portfolioLabel(clientScopeRestricted) {
  return clientScopeRestricted ? 'Assigned clients' : 'Portfolio (all clients)';
}
